import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// if locked, router events will not disable loading
// on complete because the loader has been called manually
interface LoaderState {
  loading: boolean;
  locked: boolean;
}

export const DEFAULT_LOADER_STATE_KEY = 'default';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private readonly state: { [key: string]: LoaderState } = {};

  public readonly loading$ = new BehaviorSubject<{
    key: string;
    state: LoaderState;
  }>({
    key: DEFAULT_LOADER_STATE_KEY,
    state: {
      locked: false,
      loading: false,
    },
  });

  constructor() {
    this.state[DEFAULT_LOADER_STATE_KEY] = {
      locked: false,
      loading: false,
    };
  }

  public isLoading(key = DEFAULT_LOADER_STATE_KEY): boolean {
    return this.state?.[key]?.loading || false;
  }

  public setLoading(loading: boolean, key = DEFAULT_LOADER_STATE_KEY): void {
    if (this.state?.[key]?.locked) {
      return;
    }

    this.state[key] = {
      loading,
      locked: false,
    };

    this.loading$.next({
      key,
      state: this.state[key],
    });
  }

  /// manual start/stop methods
  public start(key = DEFAULT_LOADER_STATE_KEY): void {
    this.setLoading(true, key);
    this.state[key].locked = true;
  }

  public stop(key = DEFAULT_LOADER_STATE_KEY): void {
    this.state[key].locked = false;
    this.setLoading(false, key);
  }
}
